import React from "react";
import { withRouter } from "react-router";
import Loading from "../../components/loading";
import { UserData } from "../../model/user.model";
import {
  CANDIDATURE_DETAILS_ROUTE,
  HOME_ROUTE,
  LOGIN_ROUTE,
  PROFESSIONAL_PROFILE_ROUTE,
  SIGNUP_TOKEN_EXPIRED_ROUTE,
} from "../../providers/routes";
import { AlertService } from "../../services/alert.service";
import { AuthenticationService } from "../../services/auth.service";
import OpportunityService from "../../services/opportunity.service";
import TranslationService, { t } from "../../translations/translation.service";
import "./index.css";

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

class SignupValidation extends React.Component<any> {
  state = {
    currentLang: TranslationService.getCurrentLanguage,
  };

  redirectToHome() {
    this.props.history.push("/");
  }

  async componentDidMount() {
    AuthenticationService.clearSession();
    const { username, token, type } = this.props.match.params;
    if (type === "default") {
      AuthenticationService.clearSession();
      AuthenticationService.validateSignup(username, token)
        .then((data: { user: UserData; token: string }) =>
          setTimeout(
            () =>
              (window.location.href =
                PROFESSIONAL_PROFILE_ROUTE.replace(":id", data.user._id) +
                "?step=welcome"),
            1000
          )
        )
        .catch((error: any) => {
          if (error.response.data) {
            console.error(error);
            if (error.response.data.message === "USER_NOTFOUND") {
              AlertService.error(t("Usuário não encontrado"));
            } else {
              AlertService.error(t("Erro interno ao validar email."));
            }
          }
          this.props.history.push(HOME_ROUTE);
        })
        .finally(() => {
          this.setState({ loadingSubmit: false });
        });
    } else {
      const searchParams = new URLSearchParams(this.props.location.search);
      const fromLogin = searchParams.get("fromLogin") === "true";
      const { opportunityId } = this.props.match.params;

      if (!fromLogin) {
        AuthenticationService.clearSession();

        try {
          const validation = await AuthenticationService.validateAdvancedSignupToken(
            username,
            token
          );

          console.log("[SignupValidation] validateAdvancedSignupToken", {
            status: validation?.status,
            valid: validation?.data?.valid,
            hasErrorMessage: !!validation?.data?.errorMessage,
            responseKeys: Object.keys(validation?.data || {}),
          });

          const isInvalidByStatus = validation.status !== 200;
          const isInvalidByFlag = validation.data?.valid === false;
          const isInvalidByError = !!validation.data?.errorMessage;

          if (isInvalidByStatus || isInvalidByFlag || isInvalidByError) {
            throw new Error("INVALID_TOKEN");
          }
        } catch (error) {
          console.log("[SignupValidation] token validation failed", {
            message: (error as any)?.message,
            responseStatus: (error as any)?.response?.status,
            responseData: (error as any)?.response?.data,
          });

          this.props.history.push(
            SIGNUP_TOKEN_EXPIRED_ROUTE
              .replace(":username", encodeURIComponent(username))
              .replace(":token", encodeURIComponent(token))
              .replace(":opportunityId", encodeURIComponent(opportunityId))
          );
          return;
        }

        const redirectTo = `${this.props.location.pathname}?fromLogin=true`;
        const loginSearchParams = new URLSearchParams();
        loginSearchParams.set("email", username);
        loginSearchParams.set("redirectTo", redirectTo);

        this.props.history.push({
          pathname: LOGIN_ROUTE,
          search: `?${loginSearchParams.toString()}`,
          state: {
            email: username,
            redirectTo,
          },
        });
        return;
      }

      try {
        const activeLanguage = TranslationService.getCurrentLanguage();
        const newUserAdvanced = {
          activeLanguage: activeLanguage,
          password: token,
          username: username,
          perfilUsuario: {
            mosaico: {
              escolhidas: [],
            },
            digomais: {
              lista: [],
            },
          },
          homeOffice: true,
        };
        const data = await AuthenticationService.signupAdvanced(
          newUserAdvanced
        );
        if (data.errorMessage) {
          AuthenticationService.clearSession();
          this.props.history.push(
            SIGNUP_TOKEN_EXPIRED_ROUTE
            .replace(":username", encodeURIComponent(username))
            .replace(":token", encodeURIComponent(token))
            .replace(":opportunityId", encodeURIComponent(opportunityId))
          );
          AlertService.error(data.errorMessage);
        } else {
          const objData = {
            activeLanguage: activeLanguage,
            attachmentUrl: null,
            indicadoPor: null,
            _usuario: {
              _id: data.user._id,
            },
          };
          await OpportunityService.professionalCandidature(
            opportunityId,
            objData
          );
          setTimeout(() => (window.location.href =
            CANDIDATURE_DETAILS_ROUTE.replace(":opportunityId", opportunityId) +
            "?fromSignup=true") , 1500);
        }
      } catch (err: any) {
        AuthenticationService.clearSession();
        console.log("erro: ", err);
        this.props.history.push(
          SIGNUP_TOKEN_EXPIRED_ROUTE
            .replace(":username", encodeURIComponent(username))
            .replace(":token", encodeURIComponent(token))
            .replace(":opportunityId", encodeURIComponent(opportunityId))
        );
      } finally {
        this.setState({ loadingSubmit: false });
      }
    }
  }

  render() {
    return (
      <>
        <Loading show={true}></Loading>
      </>
    );
  }
}

export default withRouter(SignupValidation);

//TODO: 
//Mostar mensagem ao usuario em caso de falha e retornar para o Home;
//Remover dados nulos caso o fluxo falhe; - feito